import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {classToClass, plainToClass} from "class-transformer";
import {ConfirmationService, SelectItem} from 'primeng/api';

import {GrowlService} from "@app/core";
import {
  ActionStatusTypeEnum,
  ApprovalStatusType,
  CommonTransformationService,
  GrowlType,
  PartnerAdditionalInfo,
  PrimeNgConfig,
  PrimeNgSupportService,
  TableColumn,
  TradingPartner,
  TradingPartnerService
} from "@app/shared";
import {Validation} from '@app/shared/enums/validation.enum';

@Component({
  selector: 'app-org-additional-info',
  templateUrl: './org-additional-info.component.html',
  styleUrls: ['./org-additional-info.component.css'],
  providers: [ConfirmationService]
})
export class OrgAdditionalInfoComponent implements OnInit, OnChanges, AfterViewInit {

  ApprovalStatusType: typeof ApprovalStatusType = ApprovalStatusType;
  PrimeNgConfig: typeof PrimeNgConfig = PrimeNgConfig;
  Validation: typeof Validation = Validation;

  additionalInfoToEdit: PartnerAdditionalInfo;
  selectedAdditionalInfo: PartnerAdditionalInfo;

  displayDialog: boolean = false;
  newAdditionalInfo: boolean = true;

  selectedIndex: number;
  columnNameId: number;
  additionalInfosColumns: TableColumn[];

  columnNameDropdown: SelectItem<number>[];
  backupAdditionalInfos: PartnerAdditionalInfo[];

  @ViewChild('actionTemplate') actionTemplate: TemplateRef<any>;
  @Input() tradingPartnerId: number;               //might vary based on entity exp: orgId, contractId
  @Input() orgType: string;
  @Input() additionalInfos: PartnerAdditionalInfo[];
  @Input() tradingPartner: TradingPartner;
  @Output() additionalInfoChangeHandler = new EventEmitter<PartnerAdditionalInfo[]>();
  @Output() handlerSave: EventEmitter<any> = new EventEmitter();

  constructor(private confirmationService: ConfirmationService, private commonTransService: CommonTransformationService, private dataService: TradingPartnerService, private growl: GrowlService,
              private primeNgService: PrimeNgSupportService) {
  }

  ngOnChanges() {
    if (!this.additionalInfos) {
      this.additionalInfos = [];
    }
  }

  ngOnInit() {
    this.backupAdditionalInfos = plainToClass(PartnerAdditionalInfo, this.additionalInfos);
    this.getAdditionalInfo();
  }

  ngAfterViewInit() {
    this.initTableColumns();
  }

  onChangeColumnName(event: SelectItem<number>): void {
    this.columnNameId = event.value;
  }

  onClickShowAdditionalInfo(): void {
    this.newAdditionalInfo = true;
    this.additionalInfoToEdit = new PartnerAdditionalInfo();
    this.displayDialog = true;
    this.getAdditionalInfo();
  }

  onClickEditAdditionalInfo(partnerAdditionalInfo: PartnerAdditionalInfo): void {
    this.newAdditionalInfo = false;
    this.selectedAdditionalInfo = partnerAdditionalInfo;
    this.additionalInfoToEdit = classToClass(this.selectedAdditionalInfo);
    this.displayDialog = true;
  }

  onClickDeleteAdditionalInfo(partnerAdditionalInfo: PartnerAdditionalInfo): void {
    this.confirmationService.confirm({
      message: `Are you sure that you want to delete ${partnerAdditionalInfo.columnName} ?`,
      header: 'Delete Confirmation',
      accept: () => {
        this.additionalInfos = this.primeNgService.deleteById(this.additionalInfos, partnerAdditionalInfo.id);
        this.triggerValueChangedEvent();
        this.handlerSave.emit(ActionStatusTypeEnum.AdditionalInfoDeleted);
        this.getAdditionalInfo();
      },
      reject: () => {
      }
    });
  }

  onClickAddAdditionalInfo(additionalInfoToEdit: PartnerAdditionalInfo): void {
    if (additionalInfoToEdit) {
      this.setColumnName();
      additionalInfoToEdit.partnerId = this.tradingPartnerId;
      this.additionalInfos = this.primeNgService.unshift(this.additionalInfos, additionalInfoToEdit);
      const index = this.backupAdditionalInfos.findIndex(a => a.columnName == additionalInfoToEdit.columnName);
      if (index < 0) {
        this.backupAdditionalInfos = this.primeNgService.unshift(this.backupAdditionalInfos, additionalInfoToEdit);
      }
      this.displayDialog = false;
      this.triggerValueChangedEvent();
      this.handlerSave.emit(ActionStatusTypeEnum.AdditionalInfoAdded);
      this.getAdditionalInfo();
    } else {
      console.warn("additionalInfo is empty");
    }
  }


  onClickUpdateAdditionalInfo(additionalInfoToEdit: PartnerAdditionalInfo): void {
    if (additionalInfoToEdit) {
      this.additionalInfos = this.primeNgService.replaceById(this.additionalInfos, additionalInfoToEdit);
      this.displayDialog = false;
      this.triggerValueChangedEvent();
      this.handlerSave.emit(ActionStatusTypeEnum.AdditionalInfoUpdated);
    } else {
      console.warn("additionalInfo is empty");
    }
  }

  onClickCancelAdditionalInfo(): void {
    this.displayDialog = false;
  }

  private getAdditionalInfo(): void {
    this.dataService.getAdditionalInfo(this.orgType, this.tradingPartnerId).subscribe(res => {
      this.columnNameDropdown = <SelectItem<number>[]>this.commonTransService.convertToDropDown("name", res, "id");
      this.filterColumnDropdown();
    });
  }

  private filterColumnDropdown(): void {
    for (const a of this.additionalInfos) {
      const index: number = this.columnNameDropdown.findIndex(c => c.label == a.columnName);
      if (index > -1) {
        this.columnNameDropdown.splice(index, 1);
      }
    }
    this.columnNameDropdown = [...this.columnNameDropdown];
  }

  private setColumnName(): void {
    this.additionalInfoToEdit.columnId = this.columnNameId;
    for (const a of this.columnNameDropdown) {
      if (a.value === this.columnNameId) {
        this.additionalInfoToEdit.columnName = a.label;
        this.additionalInfoToEdit.columnId = a.value;
      }
    }
  }

  private initTableColumns(): void {
    this.additionalInfosColumns = [
      {field: 'columnName', header: 'Column Name'},
      {field: 'columnValue', header: 'Value'},
      {field: 'action', header: 'Actions', template: this.actionTemplate}
    ];
  }

  private triggerValueChangedEvent(): void {
    this.additionalInfoChangeHandler.emit(this.additionalInfos);
  }
}
